import { Text } from '@usap/uicomponents'
import React from 'react'
import OrderItem from '../../../RMASuccess/component/OrderItem'
import { ConfirmationItemHeader } from '../style/Confirmation.css'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import ConfirmationOrderItemWmo from '../../../RMASuccess/component/ConfirmationOrderItemWmo'

const ReturnItemDetail = ({
  isDesktop,
  orderItems,
  returnId,
}) => {

  const isWmoEnabled = useWmoEnabled();
  if(isWmoEnabled){
    return (
      <ConfirmationOrderItemWmo
        orderItems={orderItems}
        isDesktop={isDesktop}
    />
    )
  }

    return (
    <>
      <ConfirmationItemHeader>
        <Text>
          Reference Number: &nbsp;
          <Text>{returnId}</Text>
        </Text>
        <Text>
          * This is not your RMA number
        </Text>
      </ConfirmationItemHeader>
      <OrderItem
        orderItems={orderItems}
        isDesktop={isDesktop}
        reasonLabel="Return Details:"
      />
  </>)
}

export default ReturnItemDetail
